export const initialValuesEmailBasic = {
  from: [],
  to: [],
  cc: [],
  subject: "",
  body: "",
};
